'use strict'

module.exports = () => () => { throw new Error('unavailable in the browser') }
